"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomParameterFilter = void 0;
const downshift_1 = require("downshift");
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const checkmarkBlue_svg_1 = __importDefault(require("../../../assets/icons/checkmarkBlue.svg"));
const chevronLeft_svg_1 = __importDefault(require("../../../assets/icons/chevronLeft.svg"));
const hooks_1 = require("../../../store/hooks");
const mapSlice_1 = require("../../../store/mapSlice");
const sensorsSlice_1 = require("../../../store/sensorsSlice");
const sessionFiltersSlice_1 = require("../../../store/sessionFiltersSlice");
const filters_1 = require("../../../types/filters");
const userStates_1 = require("../../../types/userStates");
const mapParamsHandler_1 = require("../../../utils/mapParamsHandler");
const setSensor_1 = require("../../../utils/setSensor");
const useScreenSizeDetection_1 = __importDefault(require("../../../utils/useScreenSizeDetection"));
const S = __importStar(require("./SessionFilters.style"));
const getParametersFilter = (inputValue) => {
    const lowerCasedInputValue = inputValue.toLowerCase();
    return (parameter) => !inputValue || parameter.toLowerCase().startsWith(lowerCasedInputValue);
};
const CustomParameterFilter = ({ customParameters, sessionsCount = 0, onClose = () => { }, fetchableSessionsCount, }) => {
    const [filteredParameters, setFilteredParameters] = (0, react_1.useState)(customParameters);
    const [inputValue, setInputValue] = (0, react_1.useState)("");
    const [selectedItem, setSelectedItem] = (0, react_1.useState)("");
    const { setUrlParams, sessionType, currentUserSettings, measurementType } = (0, mapParamsHandler_1.useMapParams)();
    const isMobile = (0, useScreenSizeDetection_1.default)();
    const sensors = (0, hooks_1.useAppSelector)(sensorsSlice_1.selectSensors);
    const dispatch = (0, hooks_1.useAppDispatch)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const fixedSessionTypeSelected = sessionType === filters_1.SessionTypes.FIXED;
    const { getInputProps, getMenuProps, getItemProps } = (0, downshift_1.useCombobox)({
        items: filteredParameters,
        inputValue,
        selectedItem,
        onInputValueChange: ({ inputValue }) => {
            setInputValue(inputValue);
            setFilteredParameters(customParameters.filter(getParametersFilter(inputValue)));
        },
        onSelectedItemChange: ({ selectedItem: newSelectedItem }) => {
            if (newSelectedItem) {
                const sensorData = (0, setSensor_1.setSensor)(newSelectedItem, sensors, sessionType);
                setUrlParams([
                    {
                        key: mapParamsHandler_1.UrlParamsTypes.previousUserSettings,
                        value: currentUserSettings,
                    },
                    {
                        key: mapParamsHandler_1.UrlParamsTypes.currentUserSettings,
                        value: isMobile
                            ? userStates_1.UserSettings.FiltersView
                            : currentUserSettings === userStates_1.UserSettings.CrowdMapView
                                ? userStates_1.UserSettings.CrowdMapView
                                : userStates_1.UserSettings.MapView,
                    },
                    {
                        key: mapParamsHandler_1.UrlParamsTypes.measurementType,
                        value: newSelectedItem,
                    },
                    {
                        key: mapParamsHandler_1.UrlParamsTypes.sensorName,
                        value: sensorData.sensorName,
                    },
                    {
                        key: mapParamsHandler_1.UrlParamsTypes.unitSymbol,
                        value: sensorData.unitSymbol,
                    },
                ]);
                dispatch((0, sessionFiltersSlice_1.setBasicParametersModalOpen)(false));
                setTimeout(() => {
                    dispatch((0, mapSlice_1.setFetchingData)(true));
                    setSelectedItem("");
                }, 200);
            }
        },
    });
    const goBack = () => {
        dispatch((0, sessionFiltersSlice_1.setBasicParametersModalOpen)(true));
        dispatch((0, sessionFiltersSlice_1.setCustomParametersModalOpen)(false));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(S.DesktopCustomParameters, null,
            react_1.default.createElement(S.Hr, null),
            react_1.default.createElement(S.CustomParameterWrapper, null,
                react_1.default.createElement(S.FiltersOptionHeading, null, t("filters.customParameters")),
                react_1.default.createElement(S.CustomParametersListWrapper, null,
                    react_1.default.createElement(S.CustomParametersInput, Object.assign({}, getInputProps({ value: inputValue }), { placeholder: t("filters.searchCustomParameters") })),
                    react_1.default.createElement(S.CustomParameterList, Object.assign({}, getMenuProps()), filteredParameters.map((item, index) => (react_1.default.createElement("li", Object.assign({ key: index }, getItemProps({ item, index })),
                        react_1.default.createElement(S.CustomParameter, null, item)))))))),
        react_1.default.createElement(S.MobileCustomParameters, null,
            react_1.default.createElement(S.ModalContent, null,
                react_1.default.createElement(S.Header, null,
                    react_1.default.createElement(S.ChevronBackButton, { onClick: goBack },
                        react_1.default.createElement("img", { src: chevronLeft_svg_1.default, alt: t("filters.back") })),
                    react_1.default.createElement(S.HeaderTitle, null, t("filters.selectCustomParameter"))),
                react_1.default.createElement(S.CustomParametersInput, Object.assign({}, getInputProps({ value: inputValue }), { placeholder: t("filters.searchCustomParameters") }))),
            react_1.default.createElement(S.CustomParametersListWrapper, null,
                react_1.default.createElement(S.CustomParameterList, Object.assign({}, getMenuProps()), filteredParameters.map((item, index) => (react_1.default.createElement(S.CustomParameterItem, Object.assign({ key: index }, getItemProps({ item, index })),
                    react_1.default.createElement(S.CustomParameter, { "$isActive": item === measurementType }, item),
                    item === measurementType && (react_1.default.createElement("img", { src: checkmarkBlue_svg_1.default, alt: t("filters.altCheckmark") }))))))),
            react_1.default.createElement(S.ButtonsWrapper, null,
                react_1.default.createElement(S.BackButton, { onClick: goBack }, t("filters.back")),
                react_1.default.createElement(S.MinorShowSessionsButton, { onClick: onClose }, fixedSessionTypeSelected ? (react_1.default.createElement(react_1.default.Fragment, null,
                    t("filters.showSessions"),
                    " (",
                    sessionsCount,
                    ")")) : (react_1.default.createElement(react_1.default.Fragment, null,
                    t("filters.showSessions"),
                    " ",
                    t("map.results", {
                        results: sessionsCount,
                        fetchableSessionsCount,
                    }))))))));
};
exports.CustomParameterFilter = CustomParameterFilter;
